module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/register-liga"
    }
  }, [_vm._v("Register Liga")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/season"
    }
  }, [_vm._v("Season")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/liga-personal"
    }
  }, [_vm._v("Liga Personal")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/liga-sekolah"
    }
  }, [_vm._v("Liga Sekolah")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trophy"
  }), _vm._v(" "), _c('span', [_vm._v("Duel")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e0d438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duel/Navigation.vue
// module id = 1275
// module chunks = 0